import { forwardRef } from "react";
import clsx from "clsx";
import * as Select from "@radix-ui/react-select";
import { Icon } from "react-migration/components/Icon";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { StageDotIcon } from "./StageDotIcon";

type SiteStageSelectItemProps = Select.SelectItemProps & {
  color: string;
  hidden: boolean;
};

export const SiteStageSelectItem = forwardRef<HTMLDivElement, SiteStageSelectItemProps>(
  ({ color, children, className, hidden, ...props }, forwardedRef) => {
    const { t } = useTranslation();

    return (
      <Select.Item
        ref={forwardedRef}
        className={clsx(
          "relative flex justify-stretch gap-x-1 items-center h-8 select-none rounded-md px-2 text-sm leading-none text-text-base-primary cursor-pointer data-highlighted:bg-background-button-secondary-hover data-highlighted:text-text-base-active-hover data-highlighted:outline-hidden data-checked:text-text-base-active",
          className
        )}
        {...props}
      >
        <div className="flex items-center overflow-hidden gap-x-2">
          <StageDotIcon color={color} />
          <span className="text-sm truncate text-text-base-primary">{children}</span>
        </div>
        {hidden && (
          <span className="text-neutral-400 text-nowrap justify-self-end">
            {t("sites.save_site.save_site_dropdown.hidden")}
          </span>
        )}
        <Select.ItemIndicator className="inline-flex w-[25px] items-center justify-center ml-auto">
          <Icon icon="icon-lt-check-line text-text-base-active" />
        </Select.ItemIndicator>
      </Select.Item>
    );
  }
);

SiteStageSelectItem.displayName = "SiteStageSelectItem";
